import { useLocation, useNavigate } from "react-router-dom";
import { useParentContext } from "../context/ParentContext";
import { useState } from "react";
import { Button } from "@mui/material";
import "./RequestForDoctor.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const RequestForDoctor = () => {
  const location = useLocation();
  const { child, redFlags } = location.state || {};
  const newMessage = redFlags.map((flag) => flag).join(", ");
  const { parentState, requestForDoctor } = useParentContext();
  const [message, setMessage] = useState(newMessage);
  const navigate = useNavigate();

  function handleSubmit(e) {
    e.preventDefault();
    const payloadChild = { ...child, message: message };
    requestForDoctor(payloadChild);
  }

  return (
    <div className="request-for-doctor-container">
      <div className="educationalMaterial-headerContainer">
        <button className="backButton" onClick={() => navigate(-1)}>
          <FontAwesomeIcon className="icon" icon={faArrowLeft} />
          <span>Back</span>
        </button>
        <h3>Request For Doctor</h3>
      </div>
      <form onSubmit={handleSubmit} className="request-for-doctor-form">
        <div>
          <label htmlFor="firstName">First Name</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={parentState.parent_first_name}
            readOnly
          />
        </div>
        <div>
          <label htmlFor="lastName">Last Name</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={parentState.parent_last_name}
            readOnly
          />
        </div>
        <div>
          <label htmlFor="phoneNumber">Phone Number</label>
          <input
            type="text"
            id="phoneNumber"
            name="phoneNumber"
            value={parentState.parent_phone_number}
            readOnly
          />
        </div>
        <div>
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <p>You can edit the default Message</p>
        </div>
        <Button type="submit" variant="contained" color="success">
          Submit
        </Button>
      </form>
    </div>
  );
};
export default RequestForDoctor;
